import type { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useUserStore } from "@/stores/useUserStore";
import { ROUTES } from "./routes";

type UserState = "partner" | "admin" | "loggedOut";

const HOME = {
  loggedOut: ROUTES.login,
  admin: ROUTES.dashboard,
  partner: ROUTES.home,
} as const;

export const ProtectedRoute = ({
  children,
  expected,
}: {
  children?: ReactNode;
  expected: UserState | UserState[];
}) => {
  const token = useUserStore((state) => state.token);
  const role = useUserStore((state) => state.user?.role);
  const userState = token && role ? role : "loggedOut";

  if (!expected.includes(userState)) {
    return <Navigate to={HOME[userState]} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
